import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useLoginMutation } from "../slices/authSlice";
import { setCustomer } from "../slices/customerSlice";
import { fetchCart } from "../slices/cartSlice";
// import { GoogleLogin } from "@react-oauth/google";
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import Input from "../components/utilComponents/Input";
import PasswordInput from "../components/utilComponents/PasswordInput";
import Button from "../components/utilComponents/Button";
import Error from "../components/message/Error";
import logo from "../assets/images/logo.png";
import { validateEmail, notEmpty } from "../utils/validation";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [login, { isLoading }] = useLoginMutation();

  const { info } = useSelector((state) => state.frontendAuth);

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const redirect = searchParams.get("redirect") || "/";

  useEffect(() => {
    if (info) {
      navigate(redirect);
    }
  }, [info, redirect, navigate]);

  // Standard Login Handler
  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   if (!validateEmail(email)) {
  //     setError("Invalid email address");
  //     return;
  //   }
  //   if (!notEmpty(password)) {
  //     setError("Password cannot be empty");
  //     return;
  //   }
  //   setLoading(true);
  //   try {
  //     const response = await login({ email, password }).unwrap();
  //     dispatch(setCustomer({ ...response }));
  //     navigate(redirect);
  //   } catch (error) {
  //     setError("Invalid email or password");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setError("Invalid email address");
      return;
    }
    if (!notEmpty(password)) {
      setError("Password cannot be empty");
      return;
    }
    setLoading(true);
    try {
      const response = await login({ email, password }).unwrap();
      dispatch(setCustomer(response));
      localStorage.setItem("info", JSON.stringify(response));
      dispatch(fetchCart());
      navigate(redirect);
    } catch (error) {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  // Placeholder for Google Login
  const handleGoogleSuccess = async (response) => {
    alert("Google login is currently unavailable until HTTPS is enabled.");
  };

  // Placeholder for Facebook Login
  const handleFacebookResponse = async (response) => {
    alert("Facebook login is currently unavailable until HTTPS is enabled.");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen ">
      {error && <Error message={error} onClose={() => setError("")} />}
      <div className="bg-white p-8 rounded-xl card w-[90vw] md:w-96">
        <img src={logo} alt="logo" className="mb-12 w-40 mx-auto" />
        <form onSubmit={handleLogin}>
          <Input
            startIcon="mail"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            isFullWidth
          />
          <PasswordInput
            startIcon="lock"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            isFullWidth
            showConditions={false}
          />
          <Button type="submit" variant="primary" fullWidth isLoading={loading}>
            LOGIN
          </Button>
        </form>

        {/* Social Login Placeholder */}
        {/* Uncomment and implement when HTTPS is enabled */}
        {/* <div className="flex flex-col mt-4">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => setError("Google login failed")}
          />
          <FacebookLogin
            appId={process.env.REACT_APP_FACEBOOK_APP_ID}
            callback={handleFacebookResponse}
            render={(renderProps) => (
              <Button
                onClick={renderProps.onClick}
                variant="secondary"
                fullWidth
              >
                Login with Facebook
              </Button>
            )}
          />
        </div> */}

        <p className="mt-4 text-sm text-agLightGray text-center">
          Don’t have an account?{" "}
          <Link to="/signup">
            <span className="text-agBlue">Signup</span>
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;

// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation, Link } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { useLoginMutation } from "../slices/authSlice";
// import { setCustomer } from "../slices/customerSlice";
// // import { GoogleLogin } from "@react-oauth/google";
// // import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
// import Input from "../components/utilComponents/Input";
// import PasswordInput from "../components/utilComponents/PasswordInput";
// import Button from "../components/utilComponents/Button";
// import Error from "../components/message/Error";
// import Success from "../components/message/Success";
// import { validateEmail, notEmpty } from "../utils/validation";
// import logo from "../assets/images/logo.png";

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [login, { isLoading }] = useLoginMutation();

//   const { info } = useSelector((state) => state.frontendAuth);

//   const { search } = useLocation();
//   const searchParams = new URLSearchParams(search);
//   const redirect = searchParams.get("redirect") || "/";

//   useEffect(() => {
//     if (info) {
//       navigate(redirect);
//     }
//   }, [info, redirect, navigate]);

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     if (!validateEmail(email)) {
//       setError("Invalid email address");
//       return;
//     }
//     if (!notEmpty(password)) {
//       setError("Password cannot be empty");
//       return;
//     }
//     setLoading(true);
//     try {
//       const response = await login({ email, password }).unwrap();
//       dispatch(setCustomer({ ...response }));
//       navigate(redirect);
//     } catch (error) {
//       setError("Invalid email or password");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGoogleSuccess = async (response) => {
//     try {
//       const { credential } = response;
//       const res = await fetch("/api/customer/auth/google", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ token: credential }),
//       });
//       const data = await res.json();
//       dispatch(setCustomer({ ...data }));
//       navigate(redirect);
//     } catch (error) {
//       setError("Google login failed");
//     }
//   };

//   const handleFacebookResponse = async (response) => {
//     try {
//       const { accessToken, userID } = response;
//       const res = await fetch("/api/customer/auth/facebook", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ accessToken, userID }),
//       });
//       const data = await res.json();
//       dispatch(setCustomer({ ...data }));
//       navigate(redirect);
//     } catch (error) {
//       setError("Facebook login failed");
//     }
//   };

//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen ">
//       {error && <Error message={error} onClose={() => setError("")} />}
//       <div className="bg-white p-8 rounded-xl card w-[90vw] md:w-96">
//         <img src={logo} alt="logo" className="mb-12 w-40 mx-auto" />
//         <form onSubmit={handleLogin}>
//           <Input
//             startIcon="mail"
//             placeholder="Enter your email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             isFullWidth
//           />
//           <PasswordInput
//             startIcon="lock"
//             placeholder="Enter your password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             isFullWidth
//             showConditions={false}
//           />
//           <Button type="submit" variant="primary" fullWidth isLoading={loading}>
//             LOGIN
//           </Button>
//         </form>
//         {/* <div className="flex flex-col mt-4">
//           <GoogleLogin
//             onSuccess={handleGoogleSuccess}
//             onError={() => setError("Google login failed")}
//           />
//           <FacebookLogin
//             appId="YOUR_FACEBOOK_APP_ID"
//             callback={handleFacebookResponse}
//             render={(renderProps) => (
//               <Button
//                 onClick={renderProps.onClick}
//                 variant="secondary"
//                 fullWidth
//               >
//                 Login with Facebook
//               </Button>
//             )}
//           />
//         </div> */}
//         <p className="mt-4 text-sm text-agLightGray text-center">
//           Don’t have an account?{" "}
//           <Link to="/signup">
//             <span className="text-agBlue">Signup</span>
//           </Link>
//         </p>
//       </div>
//     </div>
//   );
// };

// export default Login;

// // ===================================================================================================================

// // import React, { useState, useEffect } from "react";
// // import { useNavigate, useLocation, Link } from "react-router-dom";
// // import { useSelector, useDispatch } from "react-redux";
// // import { useLoginMutation } from "../slices/authSlice";
// // import { setCustomer } from "../slices/vendorSlice";
// // import Input from "../components/utilComponents/Input";
// // import PasswordInput from "../components/utilComponents/PasswordInput";
// // import MFAInput from "../components/utilComponents/MFAInput";
// // import Button from "../components/utilComponents/Button";
// // import Error from "../components/message/Error";
// // import Success from "../components/message/Success";
// // import { validateEmail, notEmpty } from "../utils/validation"; // Import validation functions
// // import logo from "../assets/images/logo.png";

// // const Login = () => {
// //   const [email, setEmail] = useState("");
// //   const [password, setPassword] = useState("");
// //   const [mfaToken, setMfaToken] = useState("");
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState("");
// //   const [success, setSuccess] = useState("");
// //   const [requiresMfa, setRequiresMfa] = useState(false);
// //   const navigate = useNavigate();
// //   const dispatch = useDispatch();
// //   const [login, { isLoading }] = useLoginMutation();

// //   const { info } = useSelector((state) => state.frontendAuth);

// //   const { search } = useLocation();
// //   const searchParams = new URLSearchParams(search);
// //   const redirect = searchParams.get("redirect") || "/";

// //   useEffect(() => {
// //     if (info) {
// //       navigate(redirect);
// //     }
// //   }, [info, redirect, navigate]);

// //   const handleLogin = async (e) => {
// //     e.preventDefault();
// //     if (!validateEmail(email)) {
// //       setError("Invalid email address");
// //       return;
// //     }
// //     if (!notEmpty(password)) {
// //       setError("Password cannot be empty");
// //       return;
// //     }
// //     setLoading(true);
// //     setError("");
// //     setSuccess("");
// //     try {
// //       const response = await login({ email, password }).unwrap();
// //       if (response.requiresMfa) {
// //         setRequiresMfa(true);
// //       } else {
// //         dispatch(setCustomer({ ...response }));
// //         setSuccess("Login successful!");
// //         navigate(redirect);
// //       }
// //     } catch (error) {
// //       setError("Invalid email or password");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleVerifyMfa = async (e) => {
// //     e.preventDefault();
// //     setLoading(true);
// //     setError("");
// //     setSuccess("");
// //     try {
// //       const response = await login({ email, password, mfaToken }).unwrap();
// //       dispatch(setCustomer({ ...response }));
// //       setSuccess("MFA verified, login successful!");
// //       navigate(redirect);
// //     } catch (error) {
// //       setError("Invalid MFA token");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   return (
// //     <div className="flex flex-col items-center justify-center min-h-screen bg-agBg ">
// //       {error && <Error message={error} onClose={() => setError("")} />}
// //       {success && <Success message={success} onClose={() => setSuccess("")} />}
// //       <div className="bg-white p-8 rounded-xl shadow-md w-[90vw] md:w-96">
// //         <img src={logo} alt="logo" className="mb-12 w-40 mx-auto" />
// //         {requiresMfa ? (
// //           <form onSubmit={handleVerifyMfa}>
// //             <h2 className="mb-4">Enter MFA Code</h2>
// //             <MFAInput length={6} onComplete={setMfaToken} autoFocus />
// //             <p className="py-2"></p>
// //             <Button
// //               type="submit"
// //               variant="primary"
// //               fullWidth={true}
// //               isActive={!isLoading}
// //               isLoading={isLoading}
// //             >
// //               Verify MFA
// //             </Button>
// //           </form>
// //         ) : (
// //           <form onSubmit={handleLogin}>
// //             <Input
// //               // type="email"
// //               startIcon="mail"
// //               placeholder="Enter your email"
// //               value={email}
// //               onChange={(e) => setEmail(e.target.value)}
// //               isFullWidth
// //             />
// //             <PasswordInput
// //               startIcon="lock"
// //               placeholder="Enter your password"
// //               value={password}
// //               onChange={(e) => setPassword(e.target.value)}
// //               isFullWidth
// //               showConditions={false} // Hide password strength conditions
// //             />
// //             <Link to="/forgot-password">
// //               <p className="mt-4 text-sm text-agBlue text-right mb-4">
// //                 Forgot password?
// //               </p>
// //             </Link>

// //             <Button
// //               type="submit"
// //               variant="primary"
// //               fullWidth={true}
// //               isActive={!loading}
// //               isLoading={isLoading} // Pass isLoading prop
// //             >
// //               LOGIN
// //             </Button>
// //           </form>
// //         )}
// //         <p className="mt-4 text-sm text-agLightGray text-center">
// //           Don’t have an account?{" "}
// //           <Link to="/signup">
// //             <span className="text-agBlue">Signup</span>
// //           </Link>
// //         </p>
// //       </div>
// //       <div className="mt-4 md:mt-8">
// //         <p className="text-center text-sm text-agLightGray">Need support?</p>
// //         <p className="text-center text-sm text-agLightGray">
// //           Contact us at support@agrolinka.com
// //         </p>
// //         <p className="text-center text-sm text-agLightGray">
// //           &copy; {new Date().getFullYear()} Agrolinka
// //         </p>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Login;
